import React from 'react';
import Text from '../../Text';

// import './_component.scss';

export interface InlinePageSectionHeadingProps {
    heading: string;
}

export default function InlinePageSectionHeading({ heading }: InlinePageSectionHeadingProps) {
    return (
        <div className="inline-page-section-heading">
            <Text baseClass="heading" variations={['size4', 'no-margin']}>
                {heading}
            </Text>
        </div>
    );
}

InlinePageSectionHeading.calculateMaxHeightPercentage = function (): number {
    return 0.09;
};
